import React from 'react';

interface ExpandIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const ExpandIcon: React.FC<ExpandIconProps> = ({
  className = '',
  color = '#000000',
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill="currentColor"
      />
      <path
        d="M6 18.75C5.81 18.75 5.62 18.68 5.47 18.53C5.18 18.24 5.18 17.76 5.47 17.47L17.47 5.47C17.76 5.18 18.24 5.18 18.53 5.47C18.82 5.76 18.82 6.24 18.53 6.53L6.53 18.53C6.38 18.68 6.19 18.75 6 18.75Z"
        fill="currentColor"
      />
      <path
        d="M18 10.75C17.59 10.75 17.25 10.41 17.25 10V6.75H14C13.59 6.75 13.25 6.41 13.25 6C13.25 5.59 13.59 5.25 14 5.25H18C18.41 5.25 18.75 5.59 18.75 6V10C18.75 10.41 18.41 10.75 18 10.75Z"
        fill="currentColor"
      />
      <path
        d="M10 18.75H6C5.59 18.75 5.25 18.41 5.25 18V14C5.25 13.59 5.59 13.25 6 13.25C6.41 13.25 6.75 13.59 6.75 14V17.25H10C10.41 17.25 10.75 17.59 10.75 18C10.75 18.41 10.41 18.75 10 18.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ExpandIcon;
